import { Box, Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { EventPhoto } from 'common-models';
import { FC } from 'react';
import { EventGalleryPhoto } from '../../events/EventGalleryPhoto';

interface EventPhotoGallerySectionProps {
    photoEventPhotos: EventPhoto[];
}

const EventPhotoGallerySection: FC<EventPhotoGallerySectionProps> = ({
    photoEventPhotos
}) => {
    const handleDownloadImage = () => Promise.resolve(undefined);
    const handleSelectImageForDownload = () => Promise.resolve(undefined);

    return (
        <Box className='event-gallery-admin-area-frame'>
            <Typography variant="h2" component="h2" gutterBottom>
                Event Photos ({photoEventPhotos.length})
            </Typography>
            <Grid container>
                {photoEventPhotos.map(photo =>
                    <EventGalleryPhoto
                        key={photo.id}
                        eventPhoto={photo}
                        isFreeOfCharge={false}
                        loadLazy={false}
                        isSelectedForDownload={false}
                        downloadImage={handleDownloadImage}
                        selectImageForDownload={handleSelectImageForDownload}
                    />
                )}
                {photoEventPhotos.length === 0 && (
                    <Typography color="text.secondary" sx={{ p: 2 }}>
                        No photos uploaded yet. Use the upload form above to add photos to this event.
                    </Typography>
                )}
            </Grid>
        </Box>
    );
};

export default EventPhotoGallerySection;
